"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizationCodeResponseError = exports.RefreshTokenResponseError = exports.HTTP_CODES = void 0;
var HTTP_CODES;
(function (HTTP_CODES) {
    HTTP_CODES[HTTP_CODES["ERROR"] = 500] = "ERROR";
    HTTP_CODES[HTTP_CODES["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    HTTP_CODES[HTTP_CODES["NOT_FOUND"] = 404] = "NOT_FOUND";
    HTTP_CODES[HTTP_CODES["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    HTTP_CODES[HTTP_CODES["FORBIDDEN"] = 403] = "FORBIDDEN";
    HTTP_CODES[HTTP_CODES["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
    HTTP_CODES[HTTP_CODES["CONFLICT"] = 409] = "CONFLICT";
})(HTTP_CODES || (exports.HTTP_CODES = HTTP_CODES = {}));
class RefreshTokenResponseError extends Error {
    constructor(response) {
        super('RefreshTokenResponseError');
        this.response = response;
    }
}
exports.RefreshTokenResponseError = RefreshTokenResponseError;
class AuthorizationCodeResponseError extends Error {
    constructor(response) {
        super('AuthorizationCodeResponseError');
        this.response = response;
    }
}
exports.AuthorizationCodeResponseError = AuthorizationCodeResponseError;
